/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';

/**
 * 
 * @export
 * @interface CreateSource201Response
 */
export interface CreateSource201Response {
    /**
     * 
     * @type {Source}
     * @memberof CreateSource201Response
     */
    data?: Source;
}

/**
 * Check if a given object implements the CreateSource201Response interface.
 */
export function instanceOfCreateSource201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateSource201ResponseFromJSON(json: any): CreateSource201Response {
    return CreateSource201ResponseFromJSONTyped(json, false);
}

export function CreateSource201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSource201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SourceFromJSON(json['data']),
    };
}

export function CreateSource201ResponseToJSON(value?: CreateSource201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SourceToJSON(value.data),
    };
}

